import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatTableDataSource, MatDialog, MatSort, MatDialogRef,Sort } from '@angular/material';
import { ApiService } from '../../../api.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SessionCheckwithStaff,generateAlertMessage, getFeatureNeedtoShow} from '../../../app-general';
import { enumUIAction, enumUIFeatureView, enumUIView } from '../../../app-settings';
import { TechnologyoverlayService } from '../technologyoverlay.service';
import { DOCUMENT } from '@angular/platform-browser';
import { AlertSharedService } from './../../../_services/index';
import { Router } from '@angular/router';
import { getBoardInfoData, getBoardSetupData, getConfigSettings,setAlarmClearMode,getAlarmClearMode } from '../technologyoverlay';
import { UploadDialogComponent } from './upload-dialog/upload-dialog.component';
import { EditConfigComponent } from './edit-config/edit-config.component';
import * as XLSX from 'xlsx';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { ConfirmMessageComponent } from '../../../confirm-message/confirm-message.component';

type AOA = any[][];

@Component({
  selector: 'app-hardwiredconfiguration',
  templateUrl: './hardwiredconfiguration.component.html',
  styleUrls: ['./hardwiredconfiguration.component.scss']
})
export class HardwiredConfigurationComponent implements OnInit {
 
  SiteId = "1";
  MapSyncProcess;
  getdata;
  displayedColumns: string[]= ["BoardName","IPAddress","UDPPort","Campus","Building","Edit"];
  dataSource;
  dataSourcecnt;
  hardwireddata;
  editconfigdialogopen = 0;
  fileName: string = 'NurseCallIntegration.xlsx';
  smcurrentScreenWidth: string = 'sm';
  xscurrentScreenWidth: string = 'xs';
  mdcurrentScreenWidth: string = 'md';
  lgcurrentScreenWidth: string = 'lg';
  private _onDestroy: Subject<void> = new Subject<void>();
  
  bEditiconGroup = false;
  
  stateSymbolsData: AOA = [['State Symbol', 'State Assignment']]; 
  boardInfoData: AOA = [['Board Name','IP Address','UDP Port','Points']];
  boardSetupData: AOA = [['Board Name','Relay', 'BedA','BedB','Bath','Smoke Alarm','Staff Emergency','HiPriority','Point Name']];

  alarmClearMode: any[] = [{ modeType: 'Select', Value: 0 },{ modeType: 'Auto Clear', Value: 1 }, { modeType: 'Clear from Integration', Value: 2 }, { modeType: 'Clear on Presence', Value: 3 }];
  

  constructor(public dialog: MatDialog,private mediaObserver: MediaObserver, private apiService: ApiService,private technologyoverlayService: TechnologyoverlayService, @Inject(DOCUMENT) private document: any,
  private alertSharedService: AlertSharedService,private router: Router, public thisDialogRef: MatDialogRef<HardwiredConfigurationComponent>) {
  this.getdata = this.router.getCurrentNavigation().extras.state;
    mediaObserver.media$.subscribe((change: MediaChange) => {

      if (getFeatureNeedtoShow(enumUIFeatureView.Technology, enumUIAction.Hardwired_Configration_AddEditDelete) == enumUIView.Show) {
        this.bEditiconGroup = true;
        this.displayedColumns = ["BoardName","IPAddress","UDPPort","Campus","Building","Edit"];
      }
      else
      {
        this.displayedColumns = ["BoardName","IPAddress","UDPPort","Campus","Building"];
      }
      
    });
   }

   @ViewChild(MatSort) sort: MatSort;
   ngOnInit() {
    this.getConfigurationSettings();  
  }

   getConfigurationSettings()
  {
    let apiParam : getConfigSettings = 
    { 
      siteId: this.SiteId, 
      authKey: localStorage.getItem("Authkey")
    };
    this.technologyoverlayService.getConfigurationSettings(apiParam).pipe(takeUntil(this._onDestroy))
    .subscribe((result: any[]) => {
      if(result)
      {
        
        this.hardwireddata = (result);
        this.dataSource = new MatTableDataSource(this.hardwireddata);
        this.dataSource.data = this.hardwireddata;
        this.dataSourcecnt = this.hardwireddata.length; 
        this.dataSource.sort = this.sort; 
        const sortState: Sort = {active: 'BoardName', direction: 'asc'};
        this.sort.active = sortState.active;
        this.sort.direction = sortState.direction;
        this.sort.sortChange.emit(sortState);
      }
    });
  }
  
  editConfigurationdetails(configInfo)
  {
    try
    {     
      if(!SessionCheckwithStaff(this.router))
      {
          return;
      }
      let configdetails: any={
        FileName:configInfo.FileName,
        BoardName:configInfo.BoardName,
        IPAddress:configInfo.IPAddress,
        UDPPort:configInfo.UDPPort,
        Building:configInfo.Building,
        BuildingId:configInfo.BuildingId,
        Campus:configInfo.Campus,
        CampusId:configInfo.CampusId,
        Description:configInfo.Description,
        setupDataRowCount:configInfo.Rowcount,
        BoardId:configInfo.ConfigrationSettingsId
      }
      if(this.editconfigdialogopen == 0)
      {
          let dialogRef = this.dialog.open(EditConfigComponent,{
            disableClose: true,
            width: '1100px',
            height:'700px',
            panelClass: 'myapp-no-padding-dialog',
            autoFocus: false,
            data:configdetails
          });

          this.editconfigdialogopen = 1;
          
          dialogRef.afterClosed().subscribe(result => {   
              this.editconfigdialogopen = 0; 
              this.getConfigurationSettings();
          })
      }
    }
    catch(err)
    {
      console.log(err)
      throw new Error('hardwiredconfiguration.component.ts' + ' - editConfigurationdetails() - ' + err.message);
    }
  }

  CloseRightNav(){  
  
  } 
  uploadNewConfiguration()
  {
    let dialogRef = this.dialog.open(UploadDialogComponent, {
      disableClose: true,
      width: '450px',
      height: '200px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: ''
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getConfigurationSettings();
    })
  }
  
  downloadExcelTemplate()
  {
    let apiParam : getBoardInfoData = 
    { 
      siteId: this.SiteId, 
      authKey: localStorage.getItem("Authkey")
    };
    this.technologyoverlayService.getBoardInfoData(apiParam).pipe(takeUntil(this._onDestroy))
    .subscribe((result: any[]) => {      
      if(result)
      {
        this.boardInfoData = [['Board Name','IP Address','UDP Port','Points']];

        if(result.length > 0)
        {
          for(var nIdx = 0; nIdx < result.length; nIdx ++)
          {
            var arr = [
              result[nIdx].BoardName,
              result[nIdx].IPAddress,
              result[nIdx].UDPPort,
              result[nIdx].Points
            ];
         
            this.boardInfoData.push(arr);
          }
        }
        
      }
      let apiParam1 : getBoardSetupData = 
      { 
        siteId: this.SiteId, 
        authKey: localStorage.getItem("Authkey"), 
        boardName:''
      };
       this.technologyoverlayService.getBoardSetupDetail(apiParam1).pipe(takeUntil(this._onDestroy))
      .subscribe((setupData: any[]) => {        
        if(setupData)
        {
          this.boardSetupData = [['Board Name','Relay', 'BedA','BedB','Bath','Smoke Alarm','Staff Emergency','HiPriority','Point Name']];
          if(setupData.length > 0)
          {
            for(var nIdx = 0; nIdx < setupData.length; nIdx ++)
            {
              setupData[nIdx].BedA = setupData[nIdx].BedA.toUpperCase() === "NULL" ? "No" : setupData[nIdx].BedA;
              setupData[nIdx].BedB = setupData[nIdx].BedB.toUpperCase() === "NULL" ? "No" : setupData[nIdx].BedB;
              setupData[nIdx].Bath = setupData[nIdx].Bath.toUpperCase() === "NULL" ? "No" : setupData[nIdx].Bath;
              setupData[nIdx].SmokeAlarm = setupData[nIdx].SmokeAlarm.toUpperCase() === "NULL" ? "No" : setupData[nIdx].SmokeAlarm;
              setupData[nIdx].StaffEmergency = setupData[nIdx].StaffEmergency.toUpperCase() === "NULL" ? "No" : setupData[nIdx].StaffEmergency;
              setupData[nIdx].HiPriority = setupData[nIdx].HiPriority.toUpperCase() === "NULL" ? "No" : setupData[nIdx].HiPriority;
              var arrSetup = [
                setupData[nIdx].BoardName,
                setupData[nIdx].Relay,
                setupData[nIdx].BedA,
                setupData[nIdx].BedB,
                setupData[nIdx].Bath,
                setupData[nIdx].SmokeAlarm,
                setupData[nIdx].StaffEmergency,
                setupData[nIdx].HiPriority,
                setupData[nIdx].PointName
              ];
              this.boardSetupData.push(arrSetup);
            }
          }
        }

        this.technologyoverlayService.getStateSymbolsData(apiParam).pipe(takeUntil(this._onDestroy))
        .subscribe((stateData: any[]) => {         
          if(stateData)
          {
              this.stateSymbolsData = [['State Symbol', 'State Assignment']];

              if(stateData.length > 0)
              {
                for(var nIdx = 0; nIdx < stateData.length; nIdx ++)
                {
                  var arrstateData = [
                    stateData[nIdx].StateSymbol,
                    stateData[nIdx].StateAssignment
                  ];
              
                  this.stateSymbolsData.push(arrstateData);
                }
              }
          }
          this.downloadExcelFile(this.stateSymbolsData,this.boardInfoData,this.boardSetupData);
        });
      });
    });
  }
  applyBoardConfiguarion()
  {
    var ConfirmMessageData = {
      ConfirmMessage:  "Existing Hardwired Configurations should be clear. Do you want to change it?"
    }     
    let dialogRef = this.dialog.open(ConfirmMessageComponent, {
      disableClose: true,
      width: 'auto',
      height: '220px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: ConfirmMessageData
    });     
    dialogRef.afterClosed().subscribe(result => {     
      if(result == "Yes")
      {                     
        if(this.hardwireddata.length > 0)
        {
          this.apiService.reloadBoardConfiguration();
          generateAlertMessage(this.dialog, 'Apply Board Configuration successfully completed');
        }
        else
        {
          generateAlertMessage(this.dialog, 'Devices not available to apply configuration');
          return;
        }
      }
      else
      {        
          dialogRef.close('Cancel');          
          return;
      }
    }); 
  }
  downloadExcelFile(stateSymbolsData,boardInfoData,boardSetupData)
  {
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(stateSymbolsData);
    const ws1: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(boardInfoData);
    const ws2: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(boardSetupData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'State Symbols');
    XLSX.utils.book_append_sheet(wb, ws1, 'Board Info');
    XLSX.utils.book_append_sheet(wb, ws2, 'Board Setup');
    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }
}
